import React from 'react';
import PropTypes from 'prop-types';
import { ScaleLoader, ClipLoader } from 'react-spinners';

const LoadingPanel = ({useSmallLoadingPanel, color, children }) => (
    <span>
         {!useSmallLoadingPanel &&
            <div className="loading-panel">
                <div className="spinner">
                    <ScaleLoader color={color? color: '#91c4da'} size={28} margin="4px" />
                </div>
                <div className="text">
                    <span>
                        Laster ...
                    </span>
                </div>
            </div>
        }
        {useSmallLoadingPanel === true &&
            <div className="loading-panel small">
                <ClipLoader color={color? color: '#91c4da'} size={12} margin="4px" /> {children}
            </div>
        }

     </span>
     );

    export default LoadingPanel